var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isFixed ? 'fixedPaddingTop' : '', _vm.languageClass],attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"router-view"},[_c('router-view')],1),_c('Footer',{style:({ paddingBottom: _vm.$route.path === '/' ? '100px' : '0' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }